var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"dashboard"}},[_c('Header'),(_vm.loggedIn)?_c('side-bar'):_vm._e(),_c('SnackBar'),(_vm.isLoading)?_c('div',[_c('Loader')],1):_vm._e(),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }